import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h3 className="font-heading text-xl text-background-50 mb-4">51漫画</h3>
            <p className="text-sm text-secondary-300 leading-relaxed">
              海量漫画资源大全，免费下载免费阅读。支持手机客户端安装，随时随地畅享漫画世界。
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">首页</Link>
              <Link to="/category/热血格斗" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热血格斗</Link>
              <Link to="/category/恋爱校园" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">恋爱校园</Link>
              <Link to="/category/玄幻奇幻" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">玄幻奇幻</Link>
              <Link to="/category/科幻未来" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">科幻未来</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门推荐</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/article/xiuzhen-fanren" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">修真凡人</Link>
              <Link to="/article/longzhu-chaozhan" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">龙珠·超战记</Link>
              <Link to="/article/doupo-tiankong" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">斗破天空</Link>
              <Link to="/article/jiutian-xianyu" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">九天仙域</Link>
              <Link to="/article/xingji-lieren" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">星际猎人</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">品牌介绍</Link>
              <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">用户协议</a>
              <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">隐私政策</a>
              <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">版权声明</a>
              <a href="#" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">联系我们</a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 51漫画 版权所有 | 51漫画免费下载 · 漫画资源大全
          </p>
          <p className="text-xs text-secondary-400">
            <strong>51漫画下载</strong> · <strong>免费漫画下载</strong> · <strong>离线漫画</strong>
          </p>
        </div>
      </div>
    </footer>
  );
}